if (!customElements.get('collection-layout-switch')) {
  customElements.define(
    'collection-layout-switch',
    class CollectionLayoutSwitch extends HTMLElement {
      constructor() {
        super();

        this.layout = this.dataset.layoutSwitch;
        this.querySelectorAll('[data-layout]').forEach((button) =>
          button.addEventListener('click', this.onButtonClick.bind(this))
        );
      }

      onButtonClick(event) {
        event.preventDefault();

        this.content = document.querySelector('#product-grid');
        if (!this.content) return;

        const valueActive = this.querySelector('.is-active').dataset.layout;
        this.querySelector('.is-active').classList.remove('is-active');
        
        const value = event.target.dataset.layout;
        event.target.classList.add('is-active');

        if (this.layout == 'mobile') {
          this.content.classList.remove(`grid--${valueActive}-col-tablet-down`);
          this.content.classList.add(`grid--${value}-col-tablet-down`);
        } else {
          this.content.classList.remove(`grid--${valueActive}-col-desktop`);
          this.content.classList.add(`grid--${value}-col-desktop`);
        }
      }
    }
  );
}
